import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthService, DEFAULT_AUTHENTICATED_ROUTE } from '@core/auth/auth.service';

/** For sign-in / password-reset routes — redirect users with a valid session to home. */
export const guestCanMatch: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensureAuthenticatedForNavigation().pipe(
    map((ok) => (ok ? router.createUrlTree([DEFAULT_AUTHENTICATED_ROUTE]) : true)),
  );
};
